module.exports = __webpack_public_path__ + "assets/logo-text.9d598d8e.svg";